var map = {
	"./rootpage/cities/Hospitaverhuur-xl.webp": 57617,
	"./rootpage/corporations/Hospitaverhuur-xl.webp": 33458,
	"./rootpage/mission/Daan Donkers met hospita Ana Lucia in Colombia-xl.webp": 12841,
	"./rootpage/mission/Hospita en student aan keukentafel in Groningen-xl.webp": 79389,
	"./rootpage/mission/Hospita en student drinken thee-xl.webp": 31298,
	"./rootpage/mission/Hospita en studenten in tuin in Leiden-xl.webp": 58729,
	"./rootpage/partners/Joost Bokkers geeft presentatie over kamertekort en Hospi Housing-xl.webp": 26370,
	"./rootpage/press/Daan Donkers interview met SBS6-xl.webp": 93443,
	"./rootpage/press/Oprichters Hospi Housing Joost Daan en Maurits op bankje in tuin-xl.webp": 46021,
	"./rootpage/team/Hospita en student aan keukentafel in Groningen-xl.webp": 3284,
	"./team/daan-xl.webp": 54318,
	"./team/daniel-xl.webp": 61740,
	"./team/davide-xl.webp": 42225,
	"./team/eleonora-xl.webp": 16380,
	"./team/erki-xl.webp": 70041,
	"./team/flavia-xl.webp": 36166,
	"./team/job-xl.webp": 48604,
	"./team/joost-xl.webp": 59604,
	"./team/magdalena-xl.webp": 54500,
	"./team/maurits-xl.webp": 71839,
	"./team/pavla-xl.webp": 6729,
	"./team/thierry-xl.webp": 77366,
	"./team/wouter-xl.webp": 56540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78200;